module.exports = __webpack_public_path__ + "static/img/cheer.cf4d741.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog/cheer.jpg
// module id = jwFy
// module chunks = 1